<template>
  <div class="container mt-3">
    <div class="d-flex justify-content-between align-items-center">
      <h1>{{ selectedMode }}</h1>
      <div class="d-flex align-items-center">
        <div class="form-group mb-3 d-flex align-items-center me-5">
          <strong class="me-3">Sort By: </strong>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="name"
              name="name"
              value="name"
              v-model="sortBy"
            />
            <label class="form-check-label" for="name">Name</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              id="date"
              name="date"
              value="date"
              v-model="sortBy"
            />
            <label class="form-check-label" for="date">Date</label>
          </div>
        </div>
        <div class="form-group mb-3 d-flex align-items-center">
          <label for="selectedMode" class="form-label mb-0 me-3 fw-bold"
            >Select:</label
          >
          <select id="selectedMode" class="form-control" v-model="selectedMode">
            <option v-for="(mode, index) in modes" :key="index">
              {{ mode }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div id="chartRoot"></div>
  </div>
</template>
<script>
import Gantt from "frappe-gantt";
import flowers from "../assets/flowers.json";
import dayjs from "dayjs";
export default {
  name: "GanttChart",
  data() {
    return {
      flowers: flowers,
      tasks: null,
      gantt: null,
      selectedMode: "Flowering Time",
      sortBy: "name",
      modes: ["Flowering Time", "Sow Indoors", "Sow Outdoors"],
    };
  },
  watch: {
    sortBy() {
      this.initChart();
    },
    selectedMode() {
      this.initChart();
    },
  },
  methods: {
    formatFullDate(month) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      let monthNumber = months.indexOf(month) + 1;
      let paddedMonthNumber =
        monthNumber < 10
          ? monthNumber.toString().padStart(2, "0")
          : monthNumber;
      let year = new Date().getFullYear();
      return `${year}-${paddedMonthNumber}-01`;
    },
    initChart() {
      this.tasks = [];
      this.flowers.map((flower) => {
        let taskObj = {
          name: flower.name,
          start: "",
          end: "",
          custom_class: "",
        };
        if (this.selectedMode === "Flowering Time") {
          taskObj.start = this.formatFullDate(flower.flower_start);
          taskObj.end = this.formatFullDate(flower.flower_end);
          taskObj.custom_class = flower.flower_start;
        }
        if (this.selectedMode === "Sow Indoors") {
          if (flower.sow_indoors.length > 0) {
            let formattedDate = this.formatFullDate(flower.sow_indoors);
            taskObj.start = formattedDate;
            taskObj.end = dayjs(formattedDate)
              .add(2, "month")
              .format("YYYY-MM-DD");
            taskObj.custom_class = flower.sow_indoors;
          }
        }
        if (this.selectedMode === "Sow Outdoors") {
          if (flower.sow_outdoors.length > 0) {
            taskObj.start = this.formatFullDate(flower.sow_outdoors);
            let formattedDate = this.formatFullDate(flower.sow_outdoors);
            taskObj.start = formattedDate;
            taskObj.end = dayjs(formattedDate)
              .add(2, "month")
              .format("YYYY-MM-DD");
            taskObj.custom_class = flower.sow_outdoors;
          }
        }
        if (taskObj.start.length && taskObj.end.length) {
          this.tasks.push(taskObj);
        }
      });
      if (this.sortBy !== "name") {
        this.tasks.sort((a, b) => {
          return (a.start > b.start) - (a.start < b.start);
        });
      }
      this.gantt = new Gantt("#chartRoot", this.tasks, {
        view_mode: "Month",
        header_height: 100,
        step: 24,
        bar_height: 30,
        bar_corner_radius: 15,
        padding: 30,
        custom_popup_html: null,
      });
    },
  },
  mounted() {
    this.initChart();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "frappe-gantt/src/gantt.scss";
.form-group {
  max-width: 300px;
  text-align: left;
}

.form-control {
  background-color: transparent !important;
  color: #fff !important;
}

:deep(.gantt .upper-text),
:deep(.gantt .lower-text) {
  fill: white;
  font-weight: bold;
  font-size: 16px;
}

:deep(.gantt .bar-label) {
  font-weight: bold;
  font-size: 16px;
}

:deep(.gantt .handle) {
  display: none;
}

:deep(.gantt .row-line),
:deep(.gantt .tick.thick),
:deep(.gantt .tick),
:deep(.gantt .grid-header) {
  stroke: #666;
}

:deep(.gantt .grid-header) {
  fill: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
  stroke: 0;
  stroke-width: 0;
}
:deep(.gantt .grid-row) {
  fill: transparent;
}
:deep(.January .bar) {
  fill: red;
}

:deep(.February .bar) {
  fill: orange;
}

:deep(.March .bar) {
  fill: rgb(184, 184, 6);
}

:deep(.April .bar) {
  fill: green;
}

:deep(.May .bar) {
  fill: blue;
}

:deep(.June .bar) {
  fill: purple;
}

:deep(.July .bar) {
  fill: fuchsia;
}

:deep(.August .bar) {
  fill: rgb(150, 147, 147);
}
</style>
